import type { ReactNode } from 'react';

import { MaxWidthContentContainer } from '@repo/ui/components/elements/MaxWidthContentContainer/MaxWidthContentContainer';

import './MainContentWrapper.scss';

interface MainContentWrapperProps {
  children: ReactNode;
}

export function MainContentWrapper({ children }: MainContentWrapperProps) {
  return (
    <div className="MainContentWrapper">
      <MaxWidthContentContainer>{children}</MaxWidthContentContainer>
    </div>
  );
}
